var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    transform: "translate(-770.963 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_669948_html_code_coding_programming_web_icon_1",
    "data-name": "669948_html_code_coding_programming_web_icon 1",
    transform: "translate(770.963 3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M170,85A85,85,0,1,1,85,0,85,85,0,0,1,170,85Z",
    fill: "#0075ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M114.865,88.872H5.35A5.373,5.373,0,0,1,0,83.477V5.395A5.373,5.373,0,0,1,5.35,0H114.865a5.373,5.373,0,0,1,5.35,5.395V83.477A5.373,5.373,0,0,1,114.865,88.872Z",
    transform: "translate(24.893 40.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(24.893 41.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M120.215,14.37V5.225A5.289,5.289,0,0,0,114.865,0H5.35A5.289,5.289,0,0,0,0,5.225V14.37Z",
    fill: "#e1e3e9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.838,3.919A3.919,3.919,0,1,1,3.919,0,3.919,3.919,0,0,1,7.838,3.919Z",
    transform: "translate(29.242 44.599)",
    fill: "#f24b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M7.838,3.919A3.919,3.919,0,1,1,3.919,0,3.919,3.919,0,0,1,7.838,3.919Z",
    transform: "translate(41.205 44.599)",
    fill: "#ffb202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M7.838,3.919A3.919,3.919,0,1,1,3.919,0,3.919,3.919,0,0,1,7.838,3.919Z",
    transform: "translate(53.169 44.599)",
    fill: "#4cbb41"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebNew);
export default __webpack_public_path__ + "static/media/web-new.713d6d0912a771a03e57439f1e9c6148.svg";
export { ForwardRef as ReactComponent };